<template>
  <div class="ProjectEdit__part">
    <violet-bar>Informations principales</violet-bar>
    <help-message>
      <h3 slot="title">Titre, code, et image principale</h3>
      <p>
        L'image principale entrée ici est à votre usage interne, et ne sert qu'à
        repérer un projet d'un coup d'oeil dans la liste.
      </p>
    </help-message>
    <div class="squarebox">
      <div class="columns is-multiline">
        <div class="column is-one-third">
          <vertical-field>
            <label class="label" slot="label">Titre</label>
            <input type="text" class="input" v-model="project.name" />
          </vertical-field>
          <vertical-field>
            <label class="label" slot="label">Titre web (facultatif)</label>
            <input type="text" class="input" v-model="project.title_web" />
          </vertical-field>
          <vertical-field>
            <label class="label" slot="label">Description web</label>
            <input
              type="text"
              class="input"
              v-model="project.description_web"
            />
          </vertical-field>
          <vertical-field>
            <label for="" class="label">Statut</label>
            <div class="select is-small">
              <select name="" id="" v-model="project.statut_n">
                <option :value="'livré'">Livré</option>
                <option :value="'étude'">Étude</option>
                <option :value="'en cours'">En cours</option>
                <option :value="'concours'">Concours</option>
              </select>
            </div>
          </vertical-field>
        </div>
        <div class="column is-one-third">
          <vertical-field>
            <label for="" class="label" slot="label">Code</label>
            <input type="text" class="input" v-model="project.code" />
          </vertical-field>
          <vertical-field>
            <label for="" class="label" slot="label">Nom Serveur</label>
            <input type="text" class="input" v-model="project.name_server" />
          </vertical-field>
        </div>
        <div class="column is-one-third">
          <vertical-field>
            <label class="label" slot="label"
              >Image mise en avant sur le site (facultative)</label
            >
            <div class="MainImage__maybe__croppings">
              <picture-input
                :label="'.JPG'"
                :item="project.web_image"
                @update="project.web_image = $event.id"
              ></picture-input>
            </div>
          </vertical-field>
          <vertical-field>
            <label class="label" slot="label">Image principale</label>
            <div class="MainImage__maybe__croppings">
              <picture-input
                :label="'.JPG, RVB 300dpi'"
                :sublabel="'À dimensionner selon la charte.'"
                :item="project.main_image"
                @update="project.main_image = $event.id"
              ></picture-input>
            </div>
          </vertical-field>
          <div v-if="project.main_image">
            <button
              class="button"
              @click="show_cropping_box = !show_cropping_box"
            >
              Définir les recadrages
            </button>
          </div>
          <div class="ProjectImageCroppingBox" v-if="show_cropping_box">
            <div class="ProjectImageCroppingBox__backdrop">
              <div class="box">
                <div class="columns">
                  <div class="column">
                    <div
                      class="is-relative cropper_ref"
                      id="contains-ref-image"
                      :style="
                        crop_image_dimensions.width === 0
                          ? {}
                          : {
                              width: `${crop_image_dimensions.width}px`,
                              height: `${crop_image_dimensions.height}px`
                            }
                      "
                    >
                      <api-picture
                        :picture-id="project.main_image"
                      ></api-picture>
                      <div
                        class="cropping"
                        :class="[`${crop.name}_cropping`]"
                        v-for="(crop, index) in croppings"
                        :key="index"
                        :style="{
                          left: `${crop.left}%`,
                          top: `${crop.top}%`,
                          width: `${crop.width}%`,
                          height: `${(crop.width / 100) *
                            get_crop_ratio(crop.name) *
                            crop_image_dimensions.width}px`
                        }"
                      ></div>
                    </div>
                  </div>
                  <div class="column">
                    <h3>Large</h3>
                    <div class="field">
                      <label for="" class="label is-small">Décalage haut</label>
                      <input
                        type="range"
                        class="is-small"
                        :value="get_cropping_val('large', 'top')"
                        min="0"
                        max="100"
                        step="1"
                        @input="
                          update_cropping_val(
                            'large',
                            'top',
                            $event.target.value
                          )
                        "
                      />
                      <label for="" class="label is-small"
                        >Décalage gauche</label
                      >
                      <input
                        type="range"
                        class="is-small"
                        :value="get_cropping_val('large', 'left')"
                        min="0"
                        max="100"
                        step="1"
                        @input="
                          update_cropping_val(
                            'large',
                            'left',
                            $event.target.value
                          )
                        "
                      />
                      <label for="" class="label is-small">Largeur</label>
                      <input
                        type="range"
                        class="is-small"
                        :value="get_cropping_val('large', 'width')"
                        min="0"
                        max="100"
                        step="1"
                        @input="
                          update_cropping_val(
                            'large',
                            'width',
                            $event.target.value
                          )
                        "
                      />
                    </div>
                    <h3>Carré</h3>
                    <div class="field">
                      <label for="" class="label is-small">Décalage haut</label>
                      <input
                        type="range"
                        class="is-small"
                        :value="get_cropping_val('mobile', 'top')"
                        min="0"
                        max="100"
                        step="1"
                        @input="
                          update_cropping_val(
                            'mobile',
                            'top',
                            $event.target.value
                          )
                        "
                      />
                      <label for="" class="label is-small"
                        >Décalage gauche</label
                      >
                      <input
                        type="range"
                        class="is-small"
                        :value="get_cropping_val('mobile', 'left')"
                        min="0"
                        max="100"
                        step="1"
                        @input="
                          update_cropping_val(
                            'mobile',
                            'left',
                            $event.target.value
                          )
                        "
                      />
                      <label for="" class="label is-small">Largeur</label>
                      <input
                        type="range"
                        class="is-small"
                        :value="get_cropping_val('mobile', 'width')"
                        min="0"
                        max="100"
                        step="1"
                        @input="
                          update_cropping_val(
                            'mobile',
                            'width',
                            $event.target.value
                          )
                        "
                      />
                    </div>
                    <div class="buttons">
                      <button class="button" @click="show_cropping_box = false">
                        Fermer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PictureInput from "../../../components/Form/PictureInput";
import VerticalField from "../../../components/Form/VerticalField";
import VioletBar from "../VioletBar";
import HelpMessage from "../../../components/Form/HelpMessage";
import ApiPicture from "../../../components/Form/ApiPicture";

export default {
  name: "ProjectEdit-Main",
  components: {
    ApiPicture,
    HelpMessage,
    PictureInput,
    VerticalField,
    VioletBar
  },
  props: {
    item: {}
  },
  data() {
    return {
      show_cropping_box: false,
      crop_image_dimensions: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    },
    has_croppings() {
      return this.project.croppings && this.project.croppings.length > 0;
    },
    croppings() {
      if (!this.has_croppings) return [];
      return this.project.croppings.split(";").map(a => {
        const [name, left, top, width] = a.split(",");
        return {
          name,
          left,
          top,
          width
        };
      });
    }
  },
  methods: {
    get_crop_ratio(name) {
      return (
        {
          large: 0.5,
          mobile: 1
        }[name] || 1
      );
    },
    serialize_croppings(croppings) {
      return croppings
        .map(c => `${c.name},${c.left},${c.top},${c.width}`)
        .join(";");
    },
    update_cropping_val(name, key, val) {
      const d = this.croppings.find(n => n.name === name);
      if (!d) {
        const c = this.croppings.slice();
        let b = { name, left: 0, top: 0, width: 0 };
        b[key] = val;
        c.push(b);
        this.$set(this.item, "croppings", this.serialize_croppings(c));
      } else {
        const c = this.croppings.map(d => {
          if (d.name === name) {
            d[key] = val;
          }
          return d;
        });
        this.$set(this.item, "croppings", this.serialize_croppings(c));
      }
    },
    get_cropping_val(name, key) {
      const d = this.croppings.find(n => n.name === name);
      if (d && typeof d[key] !== "undefined") return d[key];
      return 0;
    }
  },
  mounted() {
    if (!this.has_croppings) {
      this.$set(this.project, "croppings", "large,5,5,90;mobile,10,10,50");
    }
  },
  watch: {
    show_cropping_box(val) {
      if (val) {
        this.$nextTick(() => {
          const container = document.getElementById("contains-ref-image");
          if (!container) return;
          setTimeout(() => {
            const img = container.querySelector("img");
            if (!img) return;
            const { height, width } = img.getBoundingClientRect();
            this.crop_image_dimensions.width = width;
            this.crop_image_dimensions.height = height;
          }, 1000);
        });
      }
    }
  }
};
</script>

<style lang="scss">
.ProjectImageCroppingBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999999;
}

.ProjectImageCroppingBox__backdrop {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.ProjectImageCroppingBox__backdrop .box {
}

.mobile_cropping {
  border: 1px solid red;
  position: absolute;
  &::before {
    content: "carré";
    font-size: 10px;
    color: red;
  }
  pointer-events: none;
}

.large_cropping {
  border: 1px solid blue;
  position: absolute;
  &::before {
    content: "large";
    font-size: 10px;
    color: blue;
  }
  pointer-events: none;
}

.cropper_ref {
  font-size: 0;
  border: 1px solid black;
}
</style>
